import { h, clear } from '../utils/dom.js';

export function renderComparePanel(container, state, actions) {
	clear(container);

	const { translations, compare, compareMax, i18n } = state;

	if (!translations || translations.length === 0) {
		container.appendChild(h('p', { class: 'blb-search-hint' }, state.i18n.loading));
		return;
	}

	container.appendChild(
		h('p', { class: 'blb-search-hint' }, (i18n.compareLimit || 'Compare up to %d translations at once.').replace('%d', String(compareMax)))
	);

	const list = h('div', { class: 'blb-compare-list' });

	translations.forEach((t) => {
		const checked = compare.selected.includes(t.id);
		const disabled = !checked && compare.selected.length >= compareMax;

		list.appendChild(
			h(
				'label',
				{ class: 'blb-compare-row' + (disabled ? ' blb-compare-row-disabled' : '') },
				[
					h('input', {
						type: 'checkbox',
						checked: checked ? true : undefined,
						disabled: disabled ? true : undefined,
						onChange: () => actions.toggleCompareTranslation(t.id),
					}),
					h('span', { class: 'blb-compare-row-abbrev' }, t.abbrev),
					h('span', { class: 'blb-compare-row-name' }, t.name),
				]
			)
		);
	});

	container.appendChild(list);

	container.appendChild(
		h('p', { class: 'blb-search-hint' }, `${compare.selected.length} / ${compareMax} ${state.i18n.compare || 'selected'}`)
	);

	container.appendChild(
		h(
			'button',
			{
				class: 'blb-toolbar-btn blb-active',
				disabled: compare.selected.length < 2 ? true : undefined,
				onClick: () => actions.viewCompare(),
			},
			`⇄ ${i18n.compareButton || 'View Comparison'}`
		)
	);
}
